import React, { Fragment, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../../utils/history';
import PageHeader from "../../shared/page-header";
import {
    Grid,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableContainer,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { 
    getPermissionsSelector, 
    getPermissions, 
    clearPermission,
    deletePermission} from '../../../store/admin';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { TablePaginationActions } from '../../shared/pagination';
import { EnhancedTableHead, stableSort, getSorting } from '../../shared/tableHeader';
import EditButton from '../../shared/edit-button';
import DeleteButton from '../../shared/delete-button/delete-button-view';

const useStyles = makeStyles(theme => ({
    backArrowOutter: theme.backArrowOutter,
    darkArrow: theme.darkArrow,
    button: theme.button
}));


const Permissions = ({ ...props }) => {

    const classes = useStyles();      
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [open, setOpen] = React.useState(false);
    const [selectedPermissionId, setSelectedPermissionId] = React.useState(0);

    useEffect(() => {
        const init = async () => {
            const { getPermissions, clearPermission } = props;
            clearPermission();
            await getPermissions();
        }
        init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        setOpen(false);
        setSelectedPermissionId(0);
    };

    const onDelete = (id) => {
        setSelectedPermissionId(id);
        setOpen(true);
    }

    const handleConfirmDelete = async () => {

        const {deletePermission,clearPermission} = props;
        await deletePermission(selectedPermissionId)
        clearPermission();
        setOpen(false);
    }

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = e => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };    

    const handleRequestSort = (e, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };
    
    const onEdit = (id) => {
        history.push(`/permission/${id}`);
    }

    const headCells = [
        { id: 'id', numeric: false, disablePadding: false, label: 'Id' },
        { id: 'permissionId', numeric: false, disablePadding: false, label: 'Permission Id' },
        { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
        { id: 'edit', numeric: false, disablePadding: false, label: '' },
        { id: 'delete', numeric: false, disablePadding: false, label: '' },
    ];
    
    return (
        <Fragment>
            <div className={classes.backArrowOutter}>
                <span onClick={e => history.push("/user-management")} className={classes.darkArrow}>
                    <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to Users </span>
            </div>
            <PageHeader
                title="Permissions"
                description="Manage the permissions assigned to roles."
                action={
                    <Button variant="contained" type="button" color="primary" onClick={e => history.push(`/permission/new`)}>Add Permission</Button>
                }
            />
            { props.permissions &&
                <Grid item xs={12} style={{overflow: "auto"}}>
                    
                    <TableContainer>
                        <Table 
                            className={classes.table}
                            size="small"
                            aria-labelledby="permissions"
                            aria-label="enhanced table">
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={props.permissions.length}
                                    headCells={headCells}
                                    />
                                <TableBody>
                                    {stableSort(props.permissions, getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map(permission => {
                                            return (
                                                <TableRow key={permission.id}  className={classes.tableRow}>
                                                    <TableCell component="th" scope="row" >{permission.id}</TableCell>
                                                    <TableCell component="th" scope="row" >{permission.permissionId}</TableCell>
                                                    <TableCell component="th" scope="row" >{permission.name}</TableCell>
                                                    <TableCell component="th" scope="row" ><EditButton pid={permission.id} handleEdit={onEdit} /></TableCell>
                                                    <TableCell component="th" scope="row" ><DeleteButton pid={permission.id} handleDelete={onDelete} /></TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                        </Table>                    
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25,100]}
                        component="div"
                        count={props.permissions.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                            inputProps: { 'aria-label': 'rows per page' },
                            native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />
                </Grid>   
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete Permission"}</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete selected permission?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button variant="contained" onClick={handleConfirmDelete} color="primary">
                    Yes
                </Button>
                <Button variant="contained" onClick={handleClose} color="primary" autoFocus>
                    No
                </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );    
}

const mapStateToProps = state => {

    return {
        permissions: getPermissionsSelector(state)
    };

};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({getPermissions, clearPermission, deletePermission}, dispatch)   
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Permissions)